// import myApi from '@/gavnoCode/ApiHandler';
import axios from 'axios';


const urlPart = process.env.VUE_APP_URL_API_MS;
const state = {
  SelectedSumm: 30000,
  abstractTime:1,
  MinSumm:30000,
  MaxSumm:44000,
  StepSumm:1000,
  allProducts: [],
  minBaseProduct:{},
  maxBaseProduct:{},
  minIndividualProduct:{},
  maxIndividualProduct:{},
  maxPdl:{},
  pdlDeal:[],
  pdlSumNeeded: [],
  pdlRangeMin:0,
  pdlRangeMax:0,
  pdlPeriods:[],
  pdlSelectedAmount:0,
  pdlSelectedPeriod:0,
  boxArr:[],
  selectedBoxId:0,
  // переключатель раздела "Кредитная линия" на лендинге, чисто фронтовый:
  // калькулятор и анкета общие, продукт по-прежнему решает бек по PRODUCT_ID
  selectedProduct: 'base', // 'base' | 'creditLine'
};

const getters = {
  paymentInfo: state => {
    let result = state.allProducts.filter((item)=>{
      return item.Amount == state.SelectedSumm;
    });
    if (result.length == 0) {
    return [];
    } else {
      return result[0];
    }
  },
  FixedPay: state => {
    let result = state.allProducts.filter((item)=>{
      return item.Amount == state.SelectedSumm;
    });
    if (result.length > 0) {
      return result[0].FixedPay;
    } else {
      return 0;
    }
  },
  pdlGetSelectedDeal:state=>{
    let objDeal={
      Amount:0,
      loanPeriod:0,
      OutPayments:0,
      rate:0,
      payDay:'',
      FixedPay:0,
    };
    let dealWithOutLink = JSON.parse(JSON.stringify(state.pdlDeal));
    for (let i=0;i<dealWithOutLink.length;i+=1){
      if (dealWithOutLink[i].Amount === state.pdlSelectedAmount
        && dealWithOutLink[i].loanPeriod === state.pdlPeriods[state.pdlSelectedPeriod]){
        objDeal=dealWithOutLink[i];
      }
    }
    if (state.selectedBoxId > 0) {
      for (let i=0;i<state.boxArr.length;i+=1){
        if (state.boxArr[i].Amount_client === objDeal.Amount && state.selectedBoxId == state.boxArr[i].Partner_Id) {
          objDeal.Amount_box = state.boxArr[i].Amount_box;
          objDeal.OutPaymentsWithBox =((objDeal.OutPayments * 100) + (state.boxArr[i].Amount_box * 100))/ 100;
        }
      }
    } else {
      objDeal.OutPaymentsWithBox = objDeal.OutPayments;
    }
    return objDeal;
  },
  pdlGetSelectedBox:state=>{
    let objOut={
      Amount_box:0,
      Amount_client:0,
      DLsum:0,
      Partner_Id:0,
      id:0
    };
    if (state.selectedBoxId > 0) {
      for (let i=0;i<state.boxArr.length;i+=1) {
        if (state.boxArr[i].Amount_client === state.pdlSelectedAmount){
          objOut = state.boxArr[i];
        }
      }
    }
    return objOut
  }
};

// проезд адуевскаого д3а
//

const actions = {
  // eslint-disable-next-line no-unused-vars
  findMinMAxProduct:({commit})=>{
   let baseArr = state.allProducts.filter(item=>{
      return item.ProductType == 'S'
   }).sort((a,b)=>{
     if (a.Amount > b.Amount) {
       return 1;
     }
     if (a.Amount < b.Amount) {
       return -1;
     }
     return  0;
   });
   commit('minMaxDefProduct',{
     min:baseArr[0],
     max:baseArr[baseArr.length -1]
   });
    let pdlArr = state.allProducts.filter(item=>{
      return item.ProductType == 'P'
    }).sort((a,b)=>{
      if (a.Amount > b.Amount) {
        return 1;
      }
      if (a.Amount < b.Amount) {
        return -1;
      }
      return  0;
    });
    commit('maxPdlProduct', pdlArr[pdlArr.length -1]);


    let individualArr = state.allProducts.filter(item=>{
      return item.ProductType == 'K'
    }).sort((a,b)=>{
      if (a.Amount > b.Amount) {
        return 1;
      }
      if (a.Amount < b.Amount) {
        return -1;
      }
      return  0;
    });
    commit('minMaxIndividualProduct',{
      min:individualArr[0],
      max:individualArr[individualArr.length -1]
    });


  },
  setDealStateRange:({commit}, arrValue) => {
    //обновляем данные для суммы займа, продукта, мин макс и шаг
    if (arrValue.type !== undefined) {
      try {
        commit('set' + arrValue.type, parseInt(arrValue.value, 10));
      } catch (e) {
        console.log(e)
      }
    }
  },
  getDealInfo: ({commit, dispatch}, value={}) => {
      axios.post(urlPart + `/` + value.phpFileName + `.php`, value.data)
      .then((result)=>{
        let res = result.data.result;
        if (typeof(res) == 'object' && res.length > 0) {
          let min = parseInt(res[0].Amount,10);
          let max = parseInt(res[0].Amount);
          for (let i = 0, len = res.length; i < len; i+=1) {
            res[i].Amount = parseInt(res[i].Amount,10);
            res[i]['paymentDate'] = res[i].PeriodType_id != undefined && parseInt(res[i].PeriodType_id, 10) == 1 ?
                new Intl.DateTimeFormat().format(new Date(Date.now() + 7*24*60*60*1000)) :
                new Intl.DateTimeFormat().format(new Date(Date.now() + 30*24*60*60*1000)) ;
            min = res[i].Amount < min ? res[i].Amount : min;
            max = res[i].Amount > max ? res[i].Amount : max;
          }
          commit('addProducts', res);
          commit('setMinSumm',min);
          commit('setMaxSumm',max);
          commit('setStepSumm',1000);
          dispatch('findMinMAxProduct');
            dispatch('saveSendData', {
              target: 'CALC_SUMM',
              value: state.MinSumm
            });
            commit('setSelectedSumm',state.MinSumm);
          
          
        }
      }).catch((result)=>{
        alert(result)
      })
  },





  getDiealInfo:({commit,dispatch},actionName = 'getDefaultDeal') => {
    // myApi.singleRequest({action:actionName,type:'lndAdmd'})
    // api/lndADMD/getActiveDealTypeBase.php
    console.log(actionName);
    axios({
      method: 'post',
      url: process.env.VUE_APP_URL_API+'/getActiveDealTypeBase.php'
    }).then((res)=>{
      res = res.data.Response.ExecutionResult;
      try {
        if (typeof(res) == 'object' && res.length > 0) {
          let min = parseInt(res[0].Amount,10);
          let max = parseInt(res[0].Amount);
          for (let i = 0, len = res.length; i < len; i+=1) {
            res[i].Amount = parseInt(res[i].Amount,10);
            res[i]['paymentDate'] = res[i].PeriodType_id != undefined && parseInt(res[i].PeriodType_id, 10) == 1 ?
              new Intl.DateTimeFormat().format(new Date(Date.now() + 7*24*60*60*1000)) :
              new Intl.DateTimeFormat().format(new Date(Date.now() + 30*24*60*60*1000)) ;
            min = res[i].Amount < min ? res[i].Amount : min;
            max = res[i].Amount > max ? res[i].Amount : max;
          }
          commit('addProducts', res);
          commit('setMinSumm',min);
          commit('setMaxSumm',max);
          commit('setStepSumm',1000);
          dispatch('findMinMAxProduct');
          dispatch('saveSendData', {
            target: 'CALC_SUMM',
            value: state.minBaseProduct.Amount
          });
          commit('setSelectedSumm',state.minBaseProduct.Amount);
        }
      } catch (e) {
        // console.log(e);
      }

    })
    .catch(()=>{
      // console.log(res);
    })
  },
  // pdlLoadDeal:({commit,dispatch})=>{
  //   myApi.singleRequest({
  //     'action':'getPdlDealProducts',
  //     'typeRequest':'pdlLoan'
  //   }).then((res)=>{
  //     let tmpArr =[];
  //     let tmpItem = {};
  //     for(let i=0;i<res.length;i+=1){
  //       tmpItem = res[i];
  //       tmpItem['Amount'] = parseInt(tmpItem.Amount,10);
  //       tmpItem['loanPeriod'] = parseInt(tmpItem.loanPeriod,10);
  //       tmpArr.push(tmpItem);
  //     }
  //     commit('pdlSetDeal',tmpArr);
  //     dispatch('pdlRange');
  //     dispatch('pdlAvailablePeriods');
  //   }).catch((res)=>console.log(res));
  // },
  setDealType:({commit,dispatch},arrDealType)=>{
    console.log(1)
    let tmpArr =[];
        let tmpItem = {};
        for(let i=0;i<arrDealType.length;i+=1){
          tmpItem = arrDealType[i];
          tmpItem['Amount'] = parseInt(tmpItem.Amount,10);
          tmpItem['loanPeriod'] = parseInt(tmpItem.loanPeriod,10);
          tmpArr.push(tmpItem);
        }
        commit('pdlSetDeal',tmpArr);
        dispatch('pdlRange');
        dispatch('pdlAvailablePeriods');
  },
  pdlRange:({commit})=>{

      let rangeMin = state.pdlDeal.length > 0 ? state.pdlDeal[0].Amount : 0;
      for(let i=0;i<state.pdlDeal.length;i+=1){
        rangeMin = state.pdlDeal[i].Amount < rangeMin ? state.pdlDeal[i].Amount : rangeMin;
      }

      let rangeMax = 0;
      for(let i=0;i<state.pdlDeal.length;i+=1){
        rangeMax = state.pdlDeal[i].Amount > rangeMax ? state.pdlDeal[i].Amount : rangeMax;
      }
      commit('pdlSetRange',{
        pdlRangeMin : rangeMin,
        pdlRangeMax : rangeMax
      });
      commit('pdlSetSelectedAmount',rangeMin)


  },
  pdlAvailablePeriods:({commit})=>{
      let products = [];
      let findResult;
      for(let i=0;i<state.pdlDeal.length;i+=1){
        findResult = false;
        findResult = products.find(valueF => {
          return state.pdlDeal[i].loanPeriod === valueF;
        });
        if(!findResult) {
          products.push(state.pdlDeal[i].loanPeriod);
        }
      }
      commit('pdlSetPeriods',products.sort((a,b)=>a-b));
  },
  pdlSetAmountAction:({commit},newSumm)=>{
    //если на одну сумму приходится два и более периода то находим их
    let posibleDeal = [];
    for (let i=0;i<state.pdlDeal.length;i+=1){
      if(state.pdlDeal[i].Amount === newSumm){
        posibleDeal.push(state.pdlDeal[i]);
      }
    }

    //проверяем выбранный ранее пользователем период совпадает ли с новой суммой
    let chekInclude = false;
    for(let i=0; i<posibleDeal.length; i+=1){
      if (state.pdlPeriods[state.pdlSelectedPeriod] === posibleDeal[i].loanPeriod) {
        chekInclude = true;
      }
    }
    //если все ок, на выбранной сумме выбранный период может быть
    if (chekInclude) {
      commit('pdlSetSelectedAmount',newSumm);
      return  false;
    }
    //а вот если на новой сумме выбранный ранее период отсутствует то песни и пляски
    if (!chekInclude && posibleDeal.length > 1){
      //повезло есть доступный период
      commit('pdlSetSelectedPeriod',state.pdlPeriods.indexOf(posibleDeal[posibleDeal.length-1].loanPeriod));
      commit('pdlSetSelectedAmount',newSumm);
    }
    //план гавно, слайдер дергается в припадке от такого костыля
    // else {
    //   console.group('ebobo')
    //   // попали в ебейшую херню) сумма есть доступного периода нет
    //   //улыбаемся и машем если вылезли за лимиты мин макс
    //   let maxPrev = state.pdlRangeMin;
    //   let maxPrevProduct = 0;
    //   let minNext = state.pdlRangeMax;
    //   let minNextProduct = 0;
    //   for (let i=0;i<state.pdlDeal.length;i+=1){
    //     if (state.pdlDeal[i].Amount < newSumm && maxPrev < state.pdlDeal[i].Amount ){
    //       maxPrev = state.pdlDeal[i].Amount;
    //       maxPrevProduct = state.pdlPeriods.indexOf(state.pdlDeal[i].loanPeriod)
    //     }
    //     if( state.pdlDeal[i].Amount > newSumm && minNext > state.pdlDeal[i].Amount ){
    //       minNext = state.pdlDeal[i].Amount;
    //       minNextProduct = state.pdlPeriods.indexOf(state.pdlDeal[i].loanPeriod);
    //     }
    //   }
    //   console.log({maxPrev,maxPrevProduct,minNext,minNextProduct})
    //   console.log(state.pdlSelectedAmount - newSumm)
    //   if (state.pdlSelectedAmount - newSumm <= 0) {
    //     //если сумма увеличилась по сравнению с прошлой, находим первую доступноую по возрастани.
    //     commit('pdlSetSelectedPeriod',minNextProduct);
    //     commit('pdlSetSelectedAmount',minNext);
    //
    //   } else {
    //     //если сумма уменьшилась по сравнению с прошлой, находи первую доступную по убыванию
    //
    //     commit('pdlSetSelectedPeriod',maxPrevProduct);
    //     commit('pdlSetSelectedAmount',maxPrev);
    //   }
    //   console.groupEnd('ebobo')
    // }

  },
  pdlSetPeriodAction:({commit},newPeriod)=>{
    console.log(newPeriod);
    let minAmount = null;
    let maxAmount = null;
    //получаем мин макс суммы для нового периода
    for(let i=0;i<state.pdlDeal.length;i+=1){
      if(state.pdlDeal[i].loanPeriod === state.pdlPeriods[newPeriod]){
        if (minAmount === null) {minAmount = state.pdlDeal[i].Amount}
        else if (minAmount > state.pdlDeal[i].Amount) {minAmount = state.pdlDeal[i].Amount}
        if (maxAmount === null) {maxAmount = state.pdlDeal[i].Amount}
        else if (maxAmount < state.pdlDeal[i].Amount) {maxAmount = state.pdlDeal[i].Amount}
      }
    }
    //если текущая сумма не попадает в новый период ставим новую возможную
    if(!(state.pdlSelectedAmount > minAmount && state.pdlSelectedAmount < maxAmount)){
      commit('pdlSetSelectedAmount',minAmount);
    }
    commit('pdlSetSelectedPeriod',newPeriod);
  },
  onlyPdl:({commit,dispatch},value)=>{
    commit('pdlSetRange',{
      pdlRangeMin:state.pdlRangeMin,
      pdlRangeMax:value
    });
    dispatch('pdlSetAmountAction',value);
  },
  // removeProduct:({commit,dispatch},stayBaseProduct)=>{
    // let newArr = [];
    // for(let i = 0; i < state.pdlDeal.length; i+=1){
    //   if(stayBaseProduct) {
    //     if (state.pdlDeal[i].loanPeriod === 52) {
    //       newArr.push(state.pdlDeal[i])
    //     }
    //   } else {
    //     if (state.pdlDeal[i].loanPeriod !== 52) {
    //       newArr.push(state.pdlDeal[i])
    //     }
    //   }
    //
    // }
    // let summ,period;
    // if(!stayBaseProduct){
    //   console.log('1-1')
    //
    //   summ = state.pdlSelectedAmount;
    //   period = state.pdlSelectedPeriod;
    //   console.log({summ,period})
    // }
    //
    // commit('setDefaultDeal');
    // dispatch('setDealType',newArr);
    //
    // if (!stayBaseProduct){
    //   console.log('1-1')
    //   console.log({summ,period})
    //   commit('pdlSetSelectedPeriod',summ);
    //   commit('pdlSetSelectedAmount',period);
    // }
  // },

};

const mutations = {
  setSelectedBoxId:(state, value) => state.selectedBoxId = value,
  setSelectedProduct:(state, value) => state.selectedProduct = value,
  setSelectedSumm: (state, value) => state.SelectedSumm = value,
  setMinSumm: (state, value) => state.MinSumm = value,
  setMaxSumm: (state, value) => state.MaxSumm = value,
  setStepSumm: (state, value) => state.StepSumm = value,
  addProducts: (state, value) => state.allProducts = value,
  setBox: (state, value) => state.boxArr = value,
  minMaxDefProduct: (state, value) => {
    state.minBaseProduct = value.min;
    state.maxBaseProduct = value.max;
  },
  minMaxIndividualProduct: (state, value) => {
    state.minIndividualProduct = value.min;
    state.maxIndividualProduct = value.max;
  },
  setAbstractTime: (state,value) => state.abstractTime = value,
  maxPdlProduct: (state,value) => state.maxPdlProduct = value,
  pdlSetDeal:(state,value) => state.pdlDeal = value,
  pdlSetRange:(state,value) => {
    state.pdlRangeMin = value.pdlRangeMin;
    state.pdlRangeMax = value.pdlRangeMax;
  },
  pdlSetPeriods:(state,value)=>state.pdlPeriods=value,
  pdlSetSelectedAmount:(state,value)=>state.pdlSelectedAmount=value,
  pdlSetSelectedPeriod:(state,value)=>state.pdlSelectedPeriod=value,
  setDefaultDeal(state){
    state.pdlDeal = [];
    state.pdlSumNeeded= [];
    state.pdlRangeMin=0;
    state.pdlRangeMax=0;
    state.pdlPeriods=[];
    state.pdlSelectedAmount=0;
    state.pdlSelectedPeriod=0;
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
}
